import { InvitationInformationDto } from "../../models/InvitationInformationDto";
import { invitationInformationEndpoint } from "../../utils/api/urls";
import { useApi } from "../../utils/api/useApi";
import { useToastNotification } from "../useToastNotification/useToastNotification";

export const useInvitationInformation = () => {
  const { get } = useApi<InvitationInformationDto>();
  const { showNotification } = useToastNotification();

  const getInvitationInformationSafely = async (
    workflowId: string
  ): Promise<InvitationInformationDto | null> => {
    try {
      const response = await get(invitationInformationEndpoint, {
        params: { workflowId }
      });
      return response;
    } catch (err: any) {
      showNotification(err?.message || "Error getting invitation information", "error");
      return null;
    }
  };

  return { getInvitationInformationSafely };
};
